import { useT } from "../i18n";

// «Реактивная энергия» tile for the telemetry overviews (G1/G2 and the meter):
// delivered to the grid (Q > 0) and absorbed (Q < 0) side by side, both in the
// unit of the larger one. Never a single net figure — G1 absorbed all June.
export default function ReactTile({ out, inn }: { out?: number; inn?: number }) {
  const { t } = useT();
  const o = out ?? 0, i = inn ?? 0;
  const mega = Math.max(o, i) >= 1000;
  const f = (x: number) => (mega ? (x / 1000).toFixed(2) : x >= 100 ? x.toFixed(0) : x.toFixed(1));
  const unit = mega ? t("auto.mvarh") : t("auto.kvarh");
  const col = (v: number, label: string) => (
    <div style={{ minWidth: 0 }}>
      <div className="auto-tile-bigrow">
        <span className="auto-tile-big">{f(v)}</span>
        <span className="auto-tile-unit">{unit}</span>
      </div>
      <div style={{ fontSize: 12, marginTop: 4 }}>{label}</div>
    </div>
  );
  return (
    <div className="auto-tile react wide">
      <div className="auto-tile-top">
        <span className="auto-tile-icon">🔄</span>
        <span className="auto-tile-title">{t("auto.kpi_react")}</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {col(o, t("auto.react_out"))}
        {col(i, t("auto.react_in"))}
      </div>
    </div>
  );
}
